import { render, staticRenderFns } from "./PartnerTermsIndia.vue?vue&type=template&id=e8f0ceae&scoped=true"
import script from "./PartnerTermsIndia.vue?vue&type=script&lang=js"
export * from "./PartnerTermsIndia.vue?vue&type=script&lang=js"
import style0 from "./PartnerTermsIndia.vue?vue&type=style&index=0&id=e8f0ceae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f0ceae",
  null
  
)

export default component.exports